<template lang="pug">
#modal-atalho-territorio
    el-dialog(
        width='600px',
        :title='$t("mensagens.certificado.territorioAnalisado")',
        :visible.sync='mostrar',
        :close-on-click-modal='false',
        :before-close='fechar'
    )
        span.espacamento
            | {{ $t('mensagens.certificado.analiseExistente') }}

        .flexContainer(v-for='(item, index) in lista')
            .linha {{ item.geometrias[0].nomeTerritorio }}
                el-button.btnMargin(
                    type='primary',
                    @click='goToAnalise(item.id)'
                ) {{ $t('mensagens.certificado.visuExist') }}
        .botoes
            el-button(@click='fechar(false)') {{ $t('mensagens.comuns.voltar') }}
            el-button(type='primary', @click='fechar(true)') {{ $t('mensagens.certificado.novaAnaCertificacoes') }}
</template>
<script>
export default {
    name: 'ModalAtalhoTerritorio',
    props: {
        mostrar: {
            type: Boolean,
            required: true
        },
        lista: {
            type: Array
        }
    },
    methods: {
        fechar(confirma) {
            if (confirma) {
                this.$emit('fechar', true);
            }
            this.$emit('fechar', false);
        },

        goToAnalise(idCertificacao) {
            this.$router.push({
                name: 'VisualizarAnalise',
                params: { idCertificacao }
            });
        }
    }
};
</script>
<style lang="scss">
.botoes {
    display: flex;
    justify-content: space-between;
    padding-top: 10px;
}

.espacamento {
    word-break: break-word;
}
.margin {
    margin-top: 20px;
}
.linha {
    display: flex;
}
.btnMargin {
    margin: 0 20px;
    margin-right: auto;
}
.flexContainer {
    display: flex;
    justify-content: space-between;
}
</style>
